module.exports = __webpack_public_path__ + "img/jz.70f673ce.png";